'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _ZoomInOutlined = _interopRequireDefault(require('./lib/icons/ZoomInOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _ZoomInOutlined;
exports.default = _default;
module.exports = _default;